module.exports = __webpack_public_path__ + "src/img/zalando/img-pdp.a4519.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/zalando/img-pdp.jpg
// module id = 263
// module chunks = 0